import gql from "graphql-tag";

export default gql`
	mutation deletePermission($id: ID!, $parentId: ID) {
		deletePermission(id: $id, parentId: $parentId)
	}
`;
